import { gameTypes } from 'config/promoGameTypes';

/**
 * 存放審核機制相關設定
 */

/**
 * 審核機制類型
 * @property {number} VERIFY_AFTER_ENTER 登錄後驗證
 * @property {number} REALTIME_VALIDATION 即時驗證
 * @property {number} VERIFY_BY_PASS 預先驗證通過
 */
export const VERIFY_MECHANISM_TYPES = {
    VERIFY_AFTER_ENTER: 0,
    REALTIME_VALIDATION: 1,
    VERIFY_BY_PASS: 2
};

// 編輯器強制隱藏 Facebook 登入選項
const hasForceHideFacebookLoginGames = new Set([gameTypes.CART_REWARD, gameTypes.ORDER_REWARD]);
export const isHideFacebookLoginGame = gameType => hasForceHideFacebookLoginGames.has(gameType);

// 編輯器強制隱藏 Line 登入選項
const hasForceHideLineLoginGames = new Set([gameTypes.CART_REWARD, gameTypes.ORDER_REWARD]);
export const isHideLineLoginGame = gameType => hasForceHideLineLoginGames.has(gameType);

// 編輯器審核機制選項
const SPECIAL_VERIFICATION = {
    [gameTypes.ORDER_REWARD]: [
        {
            label: 'label.setting_promo.verify_mechanism.realtime',
            description: 'desc.setting_promo.verify_mechanism.realtime',
            value: VERIFY_MECHANISM_TYPES.REALTIME_VALIDATION
        }
    ],
    [gameTypes.CART_REWARD]: [
        {
            label: 'label.setting_promo.verify_mechanism.realtime',
            description: 'desc.setting_promo.verify_mechanism.realtime',
            value: VERIFY_MECHANISM_TYPES.REALTIME_VALIDATION
        }
    ],
    [gameTypes.PURCHASE_REWARD]: [
        {
            label: 'label.purchase_reward.verify_after_enter',
            description: 'label.purchase_reward.verify_after_enter_hint',
            value: VERIFY_MECHANISM_TYPES.VERIFY_AFTER_ENTER
        },
        {
            label: 'label.setting_promo.verify_mechanism.realtime',
            description: 'desc.setting_promo.verify_mechanism.realtime',
            value: VERIFY_MECHANISM_TYPES.REALTIME_VALIDATION
        },
        {
            label: 'label.purchase_reward.verify_by_pass',
            description: 'label.purchase_reward.verify_by_pass_hint',
            value: VERIFY_MECHANISM_TYPES.VERIFY_BY_PASS
        }
    ],
    [gameTypes.COMMENT]: [
        {
            label: 'label.verify_mechanism.by_pass_title',
            description: 'label.verify_mechanism.by_pass_sub_title',
            value: VERIFY_MECHANISM_TYPES.VERIFY_BY_PASS
        },
        {
            label: 'label.manual_verify_passed',
            description: 'label.verify_mechanism.by_validate_sub_title',
            value: VERIFY_MECHANISM_TYPES.VERIFY_AFTER_ENTER
        }
    ],
    [gameTypes.MISSION_REWARD_BY_STAFF]: [
        {
            label: 'label.setting_promo.verify_mechanism.realtime',
            description: 'desc.setting_promo.verify_mechanism.realtime',
            value: VERIFY_MECHANISM_TYPES.REALTIME_VALIDATION
        }
    ]
};
export const generateVerifyMechanismOptions = gameType => {
    return (
        SPECIAL_VERIFICATION[gameType] || [
            {
                label: 'label.verify_mechanism.by_pass_title',
                value: VERIFY_MECHANISM_TYPES.VERIFY_BY_PASS
            },
            {
                label: 'label.manual_verify_passed',
                value: VERIFY_MECHANISM_TYPES.VERIFY_AFTER_ENTER
            }
        ]
    );
};
